// Copied and modified from fountain-js 0.1.10
// https://github.com/mattdaly/Fountain.js/blob/master/fountain.js

const fountainRegex = {
  title_page: /^((?:title|credit|author[s]?|source|notes|draft date|date|contact|copyright):)/gim,

  scene_heading: /^((?:\*{0,3}_?)?(?:(?:int|ext|est|int\/ext|i\/e)[. ]).+)|^(?:\.(?!\.+))(.+)/i,
  scene_number: /( *#(.+)# *)/,

  transition: /^((?:FADE (?:TO BLACK|OUT)|CUT TO BLACK)\.|.+ TO:)|^(?:> *)(.+)/,

  character: /^((?:[A-Z*_]+[0-9A-Z ._\-']*|@.*)(?:\([^\n]*\) *)*)$/,
  dialogue: /^((?:[A-Z*_]+[0-9A-Z ._\-']*|@.*)(?:\([^\n]*\) *)*)(?:\n(?!\n+))([\s\S]+)/,
  dual_dialogue: /^([A-Z*_]+[0-9A-Z (._\-')]*)\^(?:\n(?!\n+))([\s\S]+)/,
  parenthetical: /^(\(.+\))$/,

  action: /^(.+)/g,
  centered: /^\s*(?:> *)(.+)(?: *<)(\n.+)*/g,

  lyrics: /^(~)(.*)/,

  section: /^(#+)(?: *)(.*)/,
  synopsis: /^(?:=(?!=+) *)(.*)/,

  note: /^(?:\[{2}(?!\[+))(.+)(?:\]{2}(?!\[+))$/,
  note_inline: /(?:\[{2}(?!\[+))([\s\S]+?)(?:\]{2}(?!\[+))/g,
  boneyard: /\/\*[\s\S]*?\*\//gm,
  page_break: /^={3,}$/,
  line_break: /^ {2}$/,

  emphasis: /(_|\*{1,3}|_\*{1,3}|\*{1,3}_)(.+)(_|\*{1,3}|_\*{1,3}|\*{1,3}_)/g,

  splitter: /\n{2,}/g,
  cleaner: /^\n+|\n+$/,
  standardizer: /\r\n|\r/g,
  whitespacer: /^\t+|^ {3,}/gm
}

const PROSE_TO_FDX = {
  ampersand: /&(?!(?:amp;|#x|lt;|gt;))/g,
  space: /\s{2,}/g,
  newline: /\n/g,
  tab: /\t/g
}

const STRUCTURE_TO_FDX = {
  underline: /(_{1}(?=.+_{1}))(.+?)(_{1})/gm,
  italic: /(\*{1}(?=.+\*{1}))(.+?)(\*{1})/g,
  bold: /(\*{2}(?=.+\*{2}))(.+?)(\*{2})/g,
  bold_italic: /(\*{3}(?=.+\*{3}))(.+?)(\*{3})/g,
  italic_underline: /(_{1}\*{1}(?=.+\*{1}_{1})|\*{1}_{1}(?=.+_{1}\*{1}))(.+?)(\*{1}_{1}|_{1}\*{1})/g,
  bold_underline: /(_{1}\*{2}(?=.+\*{2}_{1})|\*{2}_{1}(?=.+_{1}\*{2}))(.+?)(\*{2}_{1}|_{1}\*{2})/g,
  bold_italic_underline: /(_{1}\*{3}(?=.+\*{3}_{1})|\*{3}_{1}(?=.+_{1}\*{3}))(.+?)(\*{3}_{1}|_{1}\*{3})/g,
  ...PROSE_TO_FDX
}

const regexes = {
  PROSE_TO_FDX,
  STRUCTURE_TO_FDX,
  STRUCTURE_TO_HTML: {
    ...STRUCTURE_TO_FDX,
    url: /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/g,
    boneyard: /(^\/\*|^\*\/)$/gm,
    asterisk: /\+{3}/g,
    diff: /\[\[DIFF\]\](.*?)\[\[DIFF\]\]/g
  }
}

module.exports = {
  fountainRegex,
  regexes
}
